import {Component, inject, input, OnInit, output, TrackByFunction, viewChild} from '@angular/core';
import {MatButton, MatIconButton} from '@angular/material/button';
import {MatIcon} from '@angular/material/icon';
import {MatTree, MatTreeNode, MatTreeNodeDef, MatTreeNodePadding, MatTreeNodeToggle} from '@angular/material/tree';
import {TranslatePipe} from '@ngx-translate/core';
import {Observable} from 'rxjs';
import {OwnerElement} from '../service/owner-loader.service';
import {OwnerTreeDataSourceService} from './owner-tree-data-source.service';

@Component({
  selector: 'pm-owner-tree',
  imports: [MatTree, MatTreeNode, MatIcon, MatTreeNodePadding, MatTreeNodeToggle, MatIconButton, MatTreeNodeDef,
    TranslatePipe, MatButton],
  templateUrl: './owner-tree.component.html',
  styleUrl: './owner-tree.component.scss',
})
export class OwnerTreeComponent implements OnInit {
  public root = input.required<OwnerElement>();
  public onNodeClick = output<OwnerElement>();

  private ownerTreeDataSourceService = inject(OwnerTreeDataSourceService);
  private tree = viewChild('tree', {read: MatTree});

  protected dataSource: OwnerElement[];

  ngOnInit(): void {
    const root = this.root();
    this.ownerTreeDataSourceService.initializeStore(root);
    this.dataSource = [this.ownerTreeDataSourceService.getNodeById(root.id, root.id)];
  }

  childrenAccessor = (node: OwnerElement): Observable<OwnerElement[]> => {
    const parentNode = this.ownerTreeDataSourceService.getParent(this.root().id, node);
    const matTree = this.tree();

    const parentExpanded = !parentNode || matTree.isExpanded(parentNode);
    const nodeExpanded = matTree.isExpanded(node);
    const isExpanded = parentExpanded || nodeExpanded;

    console.debug(`ChildrenAccessor for ${node.label} (${node.id}, ${nodeExpanded ? '' : 'not '}expanded), parentNode:' +
      ' ${parentNode?.label} (${parentNode?.id}, ${parentExpanded ? '' : 'not '}expanded)`);

    return this.ownerTreeDataSourceService.loadChildren(this.root().id, node, isExpanded);
  }

  hasChild = (_, parent: OwnerElement) => parent?.extraData?.hasChildren ?? false;
  protected trackByFunction: TrackByFunction<OwnerElement> = (_, node) => node.id;
  expansionKeyFunction = (dataNode: OwnerElement)=> dataNode?.id;

  nodeClicked = ($event: MouseEvent, node: OwnerElement) => {
    this.onNodeClick.emit(node);
    if ($event.stopImmediatePropagation) {
      $event.stopImmediatePropagation();
    }
    if ($event.stopPropagation) {
      $event.stopPropagation()
    }
  }
}
